import playerReducer, { IPlayerReducer } from './player';
import assetsReducer, { IAssetReducer } from './assets';
import offlineReducer, { IOffline } from 'core/slices/offline';
import websocketReducer, { IWebsocketReducer } from './websocket';
import { combineReducers } from '@reduxjs/toolkit';
import uploadReducer, { IUploadReducer } from './upload';
import searchReducer, { ISearchReducer } from './search';
import permissionReducer, { IPermissionReducer } from './permissions';
import reportReducer, { IReportReducer } from './report';
import modalReducer, { IModal } from './modals';
import bannerReducer from './banners';
import { IKeyArray } from 'types/IKeyArray';

export interface ICoreReducer {
  player: IPlayerReducer;
  assets: IAssetReducer;
  offline: IOffline;
  socket: IWebsocketReducer;
  upload: IUploadReducer;
  search: ISearchReducer;
  permissions: IPermissionReducer;
  report: IReportReducer;
  modal: IModal;
  banner: IKeyArray<number>
}

const coreReducers: any = combineReducers({
  player: playerReducer,
  assets: assetsReducer,
  offline: offlineReducer,
  socket: websocketReducer,
  upload: uploadReducer,
  search: searchReducer,
  permisions: permissionReducer,
  report: reportReducer,
  modal: modalReducer,
  banner: bannerReducer
});

export default coreReducers;
